module.exports = __webpack_public_path__ + "static/media/filter-icon.73d450e8.svg";